import { PropsWithChildren } from "react";

export const FadeContent = ({ children, isShowing }: PropsWithChildren & { isShowing: boolean }) => {
  return <div className={`transition-opacity duration-300 ${isShowing ? "opacity-100" : "opacity-0"}`}>{children}</div>;
};
